const noop = (): void => {}; // eslint-disable-line @typescript-eslint/no-empty-function

const getPointersYCoords = ({
  heightBottomLabel,
  selectedEntity,
  margin,
  yScale,
  isPositionsDisplayed,
  isStreamsDisplayed,
}: any): any => {
  const { positionYScale = noop, streamYScale = noop } = yScale;
  const yPositions = selectedEntity && selectedEntity['position'];
  const yStreams = selectedEntity && selectedEntity['streamCount'];
  const yCoordPositions =
    selectedEntity &&
    yPositions !== null &&
    positionYScale &&
    isPositionsDisplayed
      ? positionYScale(yPositions) +
        margin.topHorizontalAxe +
        heightBottomLabel / 2
      : null;
  const yCoordStreams =
    selectedEntity && yStreams !== null && streamYScale && isStreamsDisplayed
      ? streamYScale(yStreams) +
        margin.betweenGraphs +
        margin.topHorizontalAxe +
        heightBottomLabel / 2
      : null;
  return [yCoordPositions, yCoordStreams];
};

export default getPointersYCoords;
